import { Field, NumericInput, TextOutput } from '../../../../Core';
import { FieldSet } from '../../../../Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { useSelector } from 'react-redux';
import { IWorksheetComponent } from '../../../Core/types';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import deepEquals from 'Lib/Object/deepEquals';
import { hasEmptyValue, hasNonEmptyValue } from 'Lib/Any';
import { CylinderJackItem } from '../../types';

let EquipmentJackFieldSetBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const jack = useSelector(createWorksheetSelector!('CylinderJack'), deepEquals) as CylinderJackItem;
  const jackMass = useSelector(createWorksheetSelector!('CylinderJackMass'), deepEquals);
  const jackMismatch = useSelector(createWorksheetSelector!('CylinderJackCalibrationImportMismatch')) as boolean;

  return (
    <FieldSet>
      <Field
        input={<WorksheetEquipmentDropdown />}
        equipmentType="cylinder-jack"
        name="CylinderJack"
        importedCalibration={{
          Mismatch: jackMismatch,
          Mass: jackMass,
        }}
        importModel={{ Id: jack?.Id }}
      />
      <Field input={<TextOutput />} name="CylinderJackMass" visible={hasNonEmptyValue(jack?.Mass)} />
      <Field input={<NumericInput />} name="CylinderJackMass" visible={hasEmptyValue(jack?.Mass)} />
    </FieldSet>
  );
};

const EquipmentJackFieldSet = withInjectedProps(EquipmentJackFieldSetBase);
export { EquipmentJackFieldSet };
export default EquipmentJackFieldSet;
